import localStorageCache from '../../src/utils/localStorageCache'

export type Version = 'A' | 'B'
export type ABTestsInProgress = ''

export function abTest (feature: ABTestsInProgress): Version {
  const featureKey = `ab_test.${feature}`
  const storedCookie = localStorageCache.getItem(featureKey)
  if (storedCookie) return storedCookie as Version

  const version: Version = Math.random() > 0.5 ? 'A' : 'B'
  localStorageCache.setItem(featureKey, version)
  return version
}
